import { MiddlewareType } from '../schema/MiddlewareType';
import { AppContext } from '../schema/AppContext';

/**
 * Use this utility to register the app action middlewares
 */
export function registerMiddleware(middleware: MiddlewareType): Function {
    const middlewares = AppContext.middlewares;
    if (middlewares.indexOf(middleware) === -1) {
        middlewares.push(middleware);

        // return a de-register function
        return () => {
            middlewares.filter(m => m !== middleware);
        };
    }

    // no op
    return () => {};
}
